const formModel = {
    emailAddress: {
        name: 'emailAddress',
        label: 'Email Address*',
        requiredErrorMsg: 'Email Address is required',
    },
    claimNumber: {
        name: 'claimNumber',
        label: 'Claim Number*',
        requiredErrorMsg: 'Claim Number is required',
        isDisabled: true,
    },
    policyNumber: {
        name: 'policyNumber', 
        label: 'Policy Number*',
        requiredErrorMsg: 'Policy Number is required',
        isDisabled: true,
    },
    contactNumber: {
        name: 'contactNumber',
        label: 'Contact Number',
        requiredErrorMsg: 'Contact Number is required',
    },
    escalationNote: {
        name: 'escalationNote',
        label: 'Escalation Note*',
        requiredErrorMsg: 'An Escalation Note is required',
    },
    contactMethod: {
        name: 'contactMethod',
        label: 'Preferred Response Method*',
        requiredErrorMsg: 'Please select an option',
    },
    claimHandler: {
        name: 'claimHandler',
        label: 'Assigned Claims Handler*',
        requiredErrorMsg: 'A handler is required',
    },
};

export default formModel;
